<!-- 组件2   2图 -->
<template>
     <div class="ThemeTwo">
       <div class="imgBox" v-for="(item, index) of ItemDate.pictureAndLinkVOS" :key="index"  @click="jumpUrl(ItemDate.componentForwardType,item)">
         <img :src="item.pic" :alt="item.couponName">
       </div>
       <div class="clear"></div>
    </div>
</template>
<script>
 import {
    GetCoupon
  } from '../../api/topicPage.js'
    import {Toast} from "vant";
  export default {
    name: "ThemeTwo",
    data() {
      return {
      }
    },
     components: {
    [Toast.name]: Toast,
  },
    props: {
        // 滚动数组
        ItemDate: {
            type: Object
        },
         token: {
            type: String
        },
    },
    created() {
       console.log('ThemeTwo',this.ItemDate)
    },
    methods: {
       // 手动领取优惠券
    getCouponFun(access_token,couponId) {
      GetCoupon(access_token,couponId).then((data) => {
          if(data.data.code==200){
             this.$toast(data.data.msg);
              this.reload();
          }else{
             this.$toast("已领取");
        }
      })
    },
        jumpUrl(UrlType,item){
          // 跳转类型 1：链接 2：优惠券 3：商品 4：不跳转
          if(UrlType==1){
            // this.$toast('1链接')
             let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
              this.url = item.link;
              // console.log(window.WebViewJavascriptBridge);
              if (isiOS) {
                window.webkit.messageHandlers.jumpList.postMessage(this.url)
              } else {
                this.$bridge.callHandler("jumpList", this.url, res => {
                
                });
              }
              //  window.location.href=this.ItemDate.pictureAndLinkVOS[0].link
          }else if(UrlType==2){
            // 领取优惠券
            // alert('2优惠券')
             let couponId=item.couponVOS[0].id
              this.getCouponFun(this.token, couponId)
          }else if(UrlType==3){
            //  alert('3商品')
             console.log(item.productVOS[0])
            //  alert(item.productVOS[0].id+'JIA'+item.productVOS[0].isRecentExpiration)
            // 3：跳转商品详情  
            this.jumpDetail(item.productVOS[0].id,item.productVOS[0].isRecentExpiration)
          }
        },
         // 点击跳转详情页   js跳转app
      jumpDetail(id, isRecentExpiration) {
        // alert(id+'我是'+isRecentExpiration)
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let detailsData = {
          goods_id: id,
          isRecentExpiration: isRecentExpiration,
        }
        if (isiOS) {
          window.webkit.messageHandlers.jumpGoodsDetail.postMessage(detailsData)
        } else {
          this.$bridge.callHandler("jumpGoodsDetail", detailsData, res => {});
        }
      },
    },
     //   注册方法
    mounted() {

    }
  }
</script>
<style lang="scss" scoped>
.ThemeTwo{
    display: block;
    height: auto;
    width:100%;
    .imgBox{
       padding:0;
          /* width: 1.4rem; */
          width:50%;
          float: left;
          // margin-bottom: 0.08rem;
      img{
        display: block;
        width:100%;
        height:auto;
      }
    }
    .clear{
      clear: both;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ActivityTheme/ThemeTwo.vue